<template>
  <BaseGrid container>
    <BaseGrid :size="$screen !== 'l' ? 12 : 8">
      <Flex
        direction="column"
        :gap="2"
      >
        <RequestTrialBanner
          v-if="!loading"
          :showRequestTrial="showRequestTrial"
        />
        <Stats
          v-if="hasFeatureFlag('module-marketing')"
          v-test="'marketing-insights-stats'"
        />
      </Flex>
    </BaseGrid>
    <BaseGrid :size="$screen !== 'l' ? 12 : 4">
      <Tips />
    </BaseGrid>
  </BaseGrid>
</template>

<script lang="ts">
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { mapState } from 'pinia';
import { computed, defineComponent } from 'vue';
import dayjs from '@/dayjs';
import { useCompanyStore } from '@/stores/company';
import { useUserStore } from '@/stores/user';
import RequestTrialBanner from './RequestTrialBanner.vue';
import Stats from './Stats.vue';
import Tips from './Tips.vue';

export default defineComponent({
  components: {
    Tips,
    Stats,
    RequestTrialBanner,
  },
  setup() {
    const { result, loading } = useQuery(
      gql`
        query getCurrentUser {
          currentUser {
            company {
              activeSubscription {
                plan
              }
            }
          }
        }
      `,
      null,
      {
        fetchPolicy: 'cache-first',
      },
    );

    const planIsPro = computed(() => {
      const plan = result.value?.currentUser.company.activeSubscription?.plan;
      return plan === 'pro' || plan === 'prolight';
    });

    return {
      planIsPro,
      loading,
    };
  },
  computed: {
    ...mapState(useUserStore, ['hasFeatureFlag']),
    ...mapState(useCompanyStore, ['company']),
    trialHasEnded() {
      return this.company.marketingTrialEndsAt < dayjs().format();
    },
    showRequestTrial() {
      const noTrial = !this.hasFeatureFlag('module-marketing');
      const inTrial =
        this.hasFeatureFlag('module-marketing') &&
        this.company.marketingTrialEndsAt &&
        !this.trialHasEnded;

      return !this.planIsPro && (noTrial || inTrial);
    },
  },
});
</script>
